import React from 'react';
import { SvgCircleIcon, IconComponent, IconGlyphComponent } from '@shapeable/icons';

export const AncestorsIcon: IconComponent = (props) => (
  <SvgCircleIcon { ...props } glyphWidth={96} glyphHeight={96}>

  </SvgCircleIcon>
);

export const AncestorsIconGlyph: IconGlyphComponent = (props) => <AncestorsIcon { ...props } variant='glyph' />;